<script>
const rules = {
  amount: [
    { required: true, message: "Amount must not empty", trigger: 'blur' }
  ],
  note: [
    { required: true, message: "Note must not empty", trigger: 'blur' }
  ]
}
export default {
  props: {
    bank: {
      type: Object,
      default: null
    },
    biller: {
      type: Object,
      default: null
    }
  },
  computed: {
    projected() {
      let balance = this.bank !== null
        ? this.bank.balance
        : (this.biller !== null ? this.biller.balance : 0)

      return balance + parseInt(this.form.amount)
    }
  },
  data: () => ({
    rules,
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
    loading: false,
    form: {
      model: {
        type: null,
        hash: null
      },
      amount: null,
      note: ''
    }
  }),
  created() {
    if (this.bank instanceof Object) {
      Object.assign(this.form.model, { type: 'Bank', hash: this.bank.hash })
    } else {
      Object.assign(this.form.model, { type: 'Biller', hash: this.biller.hash })
    }
  },
  methods: {
    handleSuccess() {
      this.$emit('close')
      this.$notification.success({
        message: "Saved!",
        description: "Balance adjustment successfully saved!",
        onClose: () => window.location.reload()
      })
    },
    submit() {
      this.loading = true
      this.$http.post(this.routeUri('hyperion.finances.service.adjustment'), this.form)
        .then((r) => this.handleSuccess())
        .catch((e) => this.handleXhrError(e))
    }
  }
}
</script>
<template>
  <a-card type="inner" size="small" :bordered="false">
    <a-form-model :model="form" :labelCol="labelCol" :wrapperCol="wrapperCol" :rules="rules">
      <template v-if="form.model.type === 'Bank'">
        <a-divider dashed orientation="left">Bank Information</a-divider>
        <a-form-model-item label="Bank">
          <strong><a-icon type="bank" /> [{{ bank.bank_code }}] {{ bank.bank_name }}</strong>
        </a-form-model-item>
        <a-form-model-item label="Account">
          <strong><a-icon type="user" /> {{ bank.account_holder }}</strong>
        </a-form-model-item>
        <a-form-model-item label="Acc. Number">
          <strong><a-icon type="number" /> {{ bank.account_number }}</strong>
        </a-form-model-item>
        <a-form-model-item label="Current Balance">
          <strong><a-icon type="dollar" /> <currency :amount="bank.balance" /></strong>
        </a-form-model-item>
      </template>

      <template v-else-if="form.model.type === 'Biller'">
        <a-divider dashed orientation="left">Biller Information</a-divider>
        <a-form-model-item label="Name">
          <strong><a-icon type="code" /> {{ biller.name }}</strong>
        </a-form-model-item>
        <a-form-model-item label="Contact">
          <strong><a-icon type="contacts" /> {{ biller.contact_name }}</strong>
        </a-form-model-item>
        <a-form-model-item label="Current Balance">
          <strong><a-icon type="dollar" /> <currency :amount="biller.balance" /></strong>
        </a-form-model-item>
      </template>

      <a-form-model-item label="Amount" :wrapper-col="{ span: 10 }" prop="amount">
        <a-input @change="(e) => form.amount = filterNumeric(e)">
          <a-icon slot="prefix" type="dollar" />
        </a-input>
      </a-form-model-item>

      <a-form-model-item label="Note" prop="note">
        <a-textarea placeholder="Note" :rows="4" v-model="form.note" />
      </a-form-model-item>

      <a-form-model-item :wrapperCol="{ span: this.wrapperCol.span, offset: this.labelCol.span }">
        <a-row type="flex" justify="space-between">
          <a-button :loading="loading" type="primary" @click="submit" icon="save">Save</a-button>
          <h4><small>projected balance: </small> <currency :amount="projected" /></h4>
        </a-row>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>
